import FlexRow from '../../../common/components/layout/FlexRow';
import {Link} from 'react-router-dom';
import {Button, Modal} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {withTranslation} from 'react-i18next';
import ColoredHeader from '../../../common/components/layout/ColoredHeader';
import styled from 'styled-components';
import {Container} from 'reactstrap';
import Details from './tabs/Details';
import {faPencilAlt, faReceipt} from '@fortawesome/free-solid-svg-icons';


const ModalHeader = styled(Modal.Header)`
  && {
    padding: 0;
    border-bottom: 0;
  }
`;

const MargedContainer = styled(Container)`
  margin-bottom: 10px;
`;

const MargedDiv = styled.div`
  margin-left: 5px;
  margin-right: 5px;
`;

const CheckoutRowActionMerchant = ({t, checkout}) => {
  const [modalVisible, setModalVisible] = useState(false);

  return (
    <FlexRow>
      <MargedDiv>
        <Button className="btn-update" onClick={() => setModalVisible(true)}>
          <FontAwesomeIcon icon={faPencilAlt} color="#329aef" size="sm"/>
        </Button>
      </MargedDiv>
      <MargedDiv>
        <Link to={'/admin/tickets?checkout=' + checkout.id}>
          <Button className="btn-update">
            <FontAwesomeIcon icon={faReceipt} color="#329aef" size="sm"/>
          </Button>
        </Link>
      </MargedDiv>

      <Modal
        show={modalVisible}
        onHide={() => setModalVisible(false)}
        size="xl">
        <ModalHeader closeButton>
          <ColoredHeader>{t('updateCheckout')}</ColoredHeader>
        </ModalHeader>
        <MargedContainer>
          <Details checkoutId={checkout.id}/>
        </MargedContainer>
      </Modal>
    </FlexRow>
  );
};

CheckoutRowActionMerchant.propTypes = {
  t: PropTypes.func.isRequired,
  checkout: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
};

export default withTranslation('checkout')(CheckoutRowActionMerchant);
